<app-page-progress-bar />
<router-outlet />
<app-notification-toast />
